function annulationWA(payload) {
    var WA = `Anulación de consulta\n¡Hola ${payload.patient_first_name}!\nTu consulta con ${payload.doctor_name} ha sido cancelada\nEstos son los detalles de la consulta\n\nNombre del paciente: ${payload.patient_name}\n${payload.date_time}\nEn clínica: ${payload.clinic_title}`
    return WA
}

export {annulationWA}